import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { INavigationItem } from '@mds/angular-layout-primeng';

export function navigationGroupsFactory(): INavigationItem[] {
  return [
    {
      icon: 'pi pi-home',
      labelResource: _('Uss.Navigation.Home.Title'),
      routerLink: 'home',
    },
  ];
}
